export default "__VITE_ASSET__hf9323RE__"